import { createContext } from '../context';
import { EMPTY_OBJ, Component } from 'intact-vue';
var _createContext = createContext(EMPTY_OBJ),
  Provider = _createContext.Provider,
  ConfigConsumer = _createContext.Consumer,
  useContext = _createContext.useContext;
function useConfigContext() {
  var config = useContext();
  return {
    cls: function cls(name) {
      return (config.value.classNamePrefix || 'k') + "-" + name;
    },
    get k() {
      return config.value.classNamePrefix || 'k';
    },
    get disableWave() {
      return config.value.disableWave || false;
    }
  };
}
export var ConfigProvider = Provider;
export { ConfigConsumer, useConfigContext };